export default {
    GENERIC_MUTATION: 'GENERIC_MUTATION'
}
